<template>
  <div class="bodywarp">
    <div class="boxcardwrap" style="min-height:calc(100% - 30px); padding-top:0;">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="grid-content">
            <router-link :to="{path:'/BuyInvoiceList/BuyInvoiceList'}">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <b>订单查询</b>
                  <span class="label-info label-info4">执行</span>
                </div>
                <div class="text item text-center">
                  {{gentInfo}} &nbsp;&nbsp; <b class="Companys Companys4">PCS</b>
                </div>
              </el-card>
            </router-link>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <router-link :to="{path:'/OrderConfirmList/OrderConfirmList'}">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <b>订单确定</b>
                  <span class="label-info label-info2">执行</span>
                </div>
                <div class="text item text-center">
                  {{OrderQueryInfo}}&nbsp;&nbsp; <b class="Companys Companys2">PCS</b>
                </div>
              </el-card>
            </router-link>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <router-link :to="{path:'/Operation_SHOrder/Operation_SHOrder'}">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <b>送货单制作</b>
                  <span class="label-info label-info1">查看</span>
                </div>
                <div class="text item text-center">
                  {{GoodsInfo}}&nbsp;&nbsp;<b class="Companys Companys1">PCS</b>
                </div>
              </el-card>
            </router-link>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <router-link :to="{path:'/ContactUpload/ContactUpload'}">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <b>收货单</b>
                  <span class="label-info label-info3">本月</span>
                </div>
                <div class="text item text-center">
                  {{ReceiptInfo}}&nbsp;&nbsp;<b class="Companys Companys3">PCS</b>
                </div>
              </el-card>
            </router-link>
          </div>
        </el-col>

        <el-col :span="4">
          <div class="grid-content">
            <router-link :to="{path:'/ArrivalRejection/ArrivalRejection'}">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <b>到货拒收</b>
                  <span class="label-info">查看</span>
                </div>
                <div class="text item text-center">
                  {{NoInfo}}&nbsp;&nbsp;<b class="Companys">PCS</b>
                </div>
              </el-card>
            </router-link>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <router-link :to="{path:'/BeInvoiceList/BeInvoiceList'}">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <b>待开发票</b>
                  <span class="label-info">本月</span>
                </div>
                <div class="text item text-center">
                  {{BeInvoicedInfo}}&nbsp;&nbsp;<b class="Companys">PCS</b>
                </div>
              </el-card>
            </router-link>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="14">
          <div class="grid-content">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <b>待办事项</b>
                <router-link :to="{path:'/ToDoList/ToDoList'}"><span
                    class="label-info label-info2">查看全部</span></router-link>

              </div>
              <div class="text item text-center tableheight">
                <el-table :data="tableData" style="width: 100%" max-height="300" :cell-style="{ padding: '7px 0' }"
                  @row-click="openDetails">
                  <el-table-column prop="curgent" label="紧急程度" width="90">
                    <template slot-scope="scope">
                      <span v-if="scope.row.clevel">
                        <el-tag type="primary" v-if="scope.row.clevel=='普通'">{{scope.row.clevel}}</el-tag>
                        <el-tag type="danger" v-if="scope.row.clevel=='紧急'" effect="dark">{{scope.row.clevel}}</el-tag>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="cdec" label="标题" width="180" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="ctitle" label="内容" show-overflow-tooltip></el-table-column>
                  <!-- <el-table-column prop="clevel" label="紧急程度"></el-table-column> -->

                  <el-table-column prop="ddate" label="时间" width="160"></el-table-column>
                </el-table>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <b>通知公告</b>
                <router-link :to="{path:'/NoticeNotice/NoticeNotice'}"><span
                    class="label-info label-info2">查看全部</span></router-link>
              </div>
              <div class="text item text-center tableheight">
                <el-table :data="tableData1" style="width: 100%" max-height="300" :cell-style="{ padding: '7px 0' }"
                  @row-click="handleSelectionChange">
                  <el-table-column prop="clevel" label="紧急程度" width="80">
                    <template slot-scope="scope">
                      <span v-if="scope.row.clevel">
                        <el-tag type="primary" v-if="scope.row.clevel=='普通'">{{scope.row.clevel}}</el-tag>
                        <el-tag type="danger" size="small" v-if="scope.row.clevel=='紧急'"
                          effect="dark">{{scope.row.clevel}}</el-tag>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ctitel" label="公告内容" min-width="220" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="iread" label="" width="55">
                    <template slot-scope="scope">
                      <span v-if="scope.row.iread=='1'" style="color:#c0c0c0;font-size:12px;">
                        [已读]
                      </span>
                      <span v-else style="color:red;font-size:12px;">
                        [未读]
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="ddate" label="日期" width="100"></el-table-column>
                </el-table>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="14">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <b>送货年度数据</b>
            </div>
            <div class="item tableheight">
              <el-date-picker v-model="year" type="year" placeholder="选择年" class="pull-right yeardate"
                value-format="yyyy" @change="GetRKByYearList"></el-date-picker>
              <homecharts :regBaseMom="regBaseMom" v-if="echartsif" />
            </div>
          </el-card>
        </el-col>
        <el-col :span="10">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <b>服务中心</b>
            </div>
            <div class="item tableheight">
              <el-col :span="12">
                <div class="productImitation">
                  <router-link :to="{path:'/OperationManual', params: {id:1}}" target="_blank">
                    <img alt="image" class="rounded-circle m-t-xs img-fluid" src="../assets/images/zczy.png">
                    <span>操作手册</span>
                  </router-link>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="productImitation" @click="shouhou()">
                  <img alt="image" class="rounded-circle m-t-xs img-fluid" src="../assets/images/czsc.png">
                  <span>售后服务</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="productImitation" @click="fankui()">
                  <img alt="image" class="rounded-circle m-t-xs img-fluid" src="../assets/images/pxzl.png">
                  <span>意见反馈</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="productImitation">
                  <router-link :to="{path:'/CommonProblem', params: {id:1}}" target="_blank">
                    <img alt="image" class="rounded-circle m-t-xs img-fluid" src="../assets/images/wtjd.png">
                    <span>常见问题解答</span>
                  </router-link>
                </div>
              </el-col>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <afterservice :shouhouvisi="shouhouvisi" @shvisi="shif" />
    <idea :ideavisi="ideavisi" @idvisi="ideaif" v-if="ideavisi" />
    <NoticeNoticeDel :notvisi="notvisi" @notvisiif="notvisiif" v-if="notvisi" :NoticeDel="NoticeDel" />
  </div>
</template>

<script>
  import homecharts from "./homecharts/homecharts.vue";
  import afterservice from "./homecharts/afterservice.vue";
  import idea from "./homecharts/idea.vue";
  import NoticeNoticeDel from "./homecharts/NoticeNoticeDel.vue";
  export default {
    components: {
      homecharts,
      afterservice,
      idea,
      NoticeNoticeDel,
    },
    data() {
      return {
        regBaseMom: {
          name: "送货年度数据",
          date: [],
          vcont1: [],
        },
        // 紧急
        gentInfo: "",
        ReceiptInfo: "",
        // 到货拒收
        NoInfo: "",
        // 待开票
        BeInvoicedInfo: "",
        // 订单确认
        OrderQueryInfo: "",
        //送货单制作
        GoodsInfo: "",
        shouhouvisi: false,
        ideavisi: false,
        notvisi: false,
        year: "",
        echartsif: true,
        tableData: [],
        tableData1: [],
        NoticeDel: {},
      };
    },

    created() {
      console.log(window.localStorage.getItem("userdata"));
      const nowDate = new Date();
      this.year = String(nowDate.getFullYear());
      this.PruchaseToDo();
      this.GetUrgentInfo();
      this.GetArriveNoInfo();
      this.GetToBeInvoicedInfo();
      this.GetReceiptInfo();
      this.GetAnnouncementList();
      this.GetRKByYearList();
      this.GetOrderQueryInfo();
      this.GetDeliverGoodsInfo();
    },
    methods: {
      // 订单执行
      GetUrgentInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetUrgentInfo",
        }).then((res) => {
          console.log(res, "订单执行");
          if (res.data.Success) {
            if (res.data.Data.number != "") {
              this.gentInfo = parseInt(res.data.Data.number).toFixed(0);
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 收货单
      GetReceiptInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetReceiptInfo",
        }).then((res) => {
          console.log(res, "收货单");
          if (res.data.Success) {
            if (res.data.Data.number != "") {
              this.ReceiptInfo = parseInt(res.data.Data.number).toFixed(0);
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 到货拒收
      GetArriveNoInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetArriveNoInfo",
        }).then((res) => {
          console.log(res, "到货拒收");
          if (res.data.Success) {
            if (res.data.Data.number != "") {
              this.NoInfo = parseInt(res.data.Data.number).toFixed(0);
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 订单确定
      GetOrderQueryInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetOrderQueryInfo",
        }).then((res) => {
          console.log(res, "订单确定");
          if (res.data.Success) {
            if (res.data.Data.number != "") {
              this.OrderQueryInfo = parseInt(res.data.Data.number).toFixed(0);
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 送货单制作
      GetDeliverGoodsInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetDeliverGoodsInfo",
        }).then((res) => {
          console.log(res, "送货单制作");
          if (res.data.Success) {
            if (res.data.Data.number != "") {
              this.GoodsInfo = parseInt(res.data.Data.number).toFixed(0);
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },

      // 待开票
      GetToBeInvoicedInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetToBeInvoicedInfo",
        }).then((res) => {
          console.log(res, "待开票");
          if (res.data.Success) {
            if (res.data.Data.number != "") {
              this.BeInvoicedInfo = parseInt(res.data.Data.number).toFixed(0);
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 通知公告
      GetAnnouncementList() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetAnnouncementList",
        }).then((res) => {
          console.log(res, "通知公告");
          if (res.data.Success) {
            this.tableData1 = res.data.Data;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 送货年度数据
      GetRKByYearList() {
        this.echartsif = false;
        this.regBaseMom.date = [];
        this.regBaseMom.vcont1 = [];
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetRKByYearList",
          data: { year: this.year },
        }).then((res) => {
          console.log(res, "送货年度数据");
          if (res.data.Success) {
            for (let index = 0; index < res.data.Data.length; index++) {
              this.regBaseMom.date.push(res.data.Data[index].cmonth);
              this.regBaseMom.vcont1.push(res.data.Data[index].inumber);
            }
            this.echartsif = true;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 获取待办事项
      PruchaseToDo() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetPruchaseToDo",
        }).then((res) => {
          console.log(res, "获取待办事项");
          if (res.data.Success) {
            this.tableData = res.data.Data;
            for (var a = 0; a < this.tableData.length; a++) {
              if (this.tableData.ddate != "") {
                this.tableData[a].ddate =
                  this.tableData[a].ddate.substring(0, 10) +
                  "  " +
                  this.tableData[a].ddate.substring(11, 19);
              }
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },

      // 待办事项的点击事件
      openDetails(row) {
        if (row.ctype == "X_06") {
          row.id = row.cid;
          this.$router.push({ name: "Factorypricing", params: { rows: row } });
        }
        if (row.ctype == "X_05") {
          row.id = row.cid;
          this.$router.push({ name: "Rectification", params: { rows: row } });
        }
        if (row.ctype == "X_04") {
          row.id = row.cid;
          this.$router.push({ name: "AccountStatement", params: { rows: row } });
        }
        if (row.ctype == "X_03") {
          row.id = row.cid;
          this.$router.push({ name: "OnlineContract", params: { rows: row } });
        }
        if (row.ctype == "X_02") {
          row.id = row.cid;
          this.$router.push({ name: "OrderConfirm", params: { rows: row } });
        }
        if (row.ctype == "X_01") {
          row.id = row.cid;
          this.$router.push({ name: "SupInvoiceadd", params: { rows: row } });
        }
        if (row.ctype == "X_0102") {
          row.id = row.cid;
          this.$router.push({ name: "SupInvoiceaddcont", params: { rows: row } });
        }
        if (row.ctype == "X_0103") {
          row.id = row.cid;
          this.$router.push({ name: "SupInvoiceaddcom", params: { rows: row } });
        }
      },
      fankui() {
        this.ideavisi = true;
      },
      shouhou() {
        this.shouhouvisi = true;
      },
      ideaif() {
        this.ideavisi = false;
      },
      notvisiif() {
        this.notvisi = false;
        this.GetAnnouncementList();
      },
      shif(val) {
        this.shouhouvisi = val;
      },
      stateFormat(row, column, cellValue) {
        cellValue += "";
        if (!cellValue.includes(".")) cellValue += ".";
        return cellValue
          .replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
            return $1 + ",";
          })
          .replace(/\.$/, "");
      },
      handleSelectionChange(val) {
        this.NoticeDel = val;
        this.notvisi = true;
        this.$axios({
          method: "post",
          url: "CommonModule/ImportExcel/Setbs_announcementReadState",
          data: { keyid: val.id },
        }).then((res) => {
          console.log(res, "已读");
          if (res.data.Success) {
            // this.Noticefile = res.data.Data;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
    },
  };
</script>
<style scoped>
  .boxcardwrap {
    padding: 10px;
  }

  .productImitation {
    background: #f8f8f9;
    width: 80%;
    height: 135px;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
    margin: 10px auto;
    box-shadow: 0px 2px 5px #a7a7a7;
  }

  .productImitation:hover {
    box-shadow: 0px 1px 10px #a7a7a7;
  }

  .productImitation img {
    margin-top: 20px;
  }

  .productImitation span {
    display: block;
    text-align: center;
    color: darkgrey;
  }
</style>